module.exports = __webpack_public_path__ + "img/trash.b7a103af.svg";